import { render } from "./ShowOrganization.vue?vue&type=template&id=61c44874&scoped=true"
import script from "./ShowOrganization.vue?vue&type=script&lang=js"
export * from "./ShowOrganization.vue?vue&type=script&lang=js"

import "./ShowOrganization.vue?vue&type=style&index=0&id=61c44874&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c44874"]])

export default __exports__